import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import uniqueId from 'lodash/uniqueId'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Fade from '@material-ui/core/Fade'

const styles = theme => ({
  container: {
    display: 'flex',
    alignItems: 'baseline',
  },
  containerWithBorder: {
    borderLeft: '1px solid #DEDEDE',
    paddingLeft: theme.spacing.unit * 2,
    transition: theme.transitions.create('border-color'),
  },
  containerWithLeftHelper: {
    '& $input': {
      marginLeft: theme.spacing.unit,
    }
  },
  containerWithErrorMessage: {
    borderColor: theme.palette.error.main,
  },
  input: {
    flex: 1,
    maxWidth: '100%',
  },
  error: {
    marginTop: theme.spacing.unit,
  },
  label: {
    marginBottom: theme.spacing.unit,
  },
})

export const InputPropTypes = {
  className: PropTypes.any,
  withBorder: PropTypes.bool,
  label: PropTypes.any,
  leftHelper: PropTypes.any,
  errorMessage: PropTypes.any,
  id: PropTypes.any,
}

export default
@withStyles(styles)
class Input extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.func.isRequired,
    ...InputPropTypes
  }

  constructor({ id }) {
    super()
    this.id = id || uniqueId('Input')
  }

  renderLabel() {
    const { label, classes } = this.props
    return !!label && (
      <Typography
        variant="caption"
        color="textSecondary"
        component="label"
        htmlFor={this.id}
        className={classes.label}
      >
        { label }
      </Typography>
    )
  }

  renderErrorMessage() {
    const { errorMessage, classes } = this.props
    return !!errorMessage && (
      <Fade in>
        <div>
          <Typography variant="caption" color="error" className={classes.error}>
            { errorMessage }
          </Typography>
        </div>
      </Fade>
    )
  }

  render() {
    const { className, classes, leftHelper, withBorder, errorMessage, children } = this.props
    const cx = classNames(classes.container, {
      [classes.containerWithBorder]: withBorder,
      [classes.containerWithLeftHelper]: !!leftHelper,
      [classes.containerWithErrorMessage]: !!errorMessage,
    })
    return (
      <div className={className}>
        { this.renderLabel() }
        <div className={cx}>
          { leftHelper }
          <div className={classes.input}>
            { children({ id: this.id }) }
          </div>
        </div>
        { this.renderErrorMessage() }
      </div>
    )
  }
}
